import App from './App.vue';
import router from './router';
import { createApp } from 'vue';

// Popper.js is a Bootstrap dependency
import 'bootstrap';
 
 
// Bootstrap JS + CSS (v4)
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
 
// Import Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
 
// Import Font Awesome
import "@fortawesome/fontawesome-free/css/all.css";
 
// Import Bootstrap Icons
import "bootstrap-icons/font/bootstrap-icons.css"; 
 
// Import custom CSS
import './assets/style/style.css';
 
 
const jquery_instance = window.jQuery || window.$;

if (jquery_instance) {
  jquery_instance(document).ajaxComplete(function(event, xhr) {
    if (xhr.status === 401) {
      router.push("/");
    }
  });
}

// Collapsed-sidebar tooltips (::before/::after) are `position: fixed` so they can
// escape the sidebar's own overflow clipping, which means they can't rely on a
// relative-positioned ancestor for vertical placement. Anchor them to whichever
// item is actually hovered/focused via a CSS custom property.
const tooltip_trigger_selector = [
  '.sidebar-wrapper.sidebar-collapsed .sidebar-menu-item',
  '.sidebar-wrapper.sidebar-collapsed .sidebar-after-menu-item',
  '.sidebar-wrapper.sidebar-collapsed .platform-switcher-toggle',
  '.sidebar-wrapper.sidebar-collapsed .sidebar-user-management-link',
  '.sidebar-wrapper.sidebar-collapsed .sidebar-profile-link'
].join(', ');

function anchor_sidebar_tooltip(event) {
  const trigger = event.target.closest(tooltip_trigger_selector);

  if (!trigger) {
    return;
  }

  const rect = trigger.getBoundingClientRect();
  trigger.style.setProperty('--tooltip-anchor-top', `${rect.top + rect.height / 2}px`);
}

document.addEventListener('pointerover', anchor_sidebar_tooltip);
document.addEventListener('focusin', anchor_sidebar_tooltip);

createApp(App).use(router).mount('#app');
 
